import React, { createContext, useContext, useLayoutEffect, useState } from "react";
import styled from "styled-components";
import { colors } from "utils";

const ReportWarmSurface = createContext(() => {});

// Manage Groups' main content: today's #FDFCFA, or Figma's #FAF7F2 once the
// page reports the flag-on layout (the one list or the flag-on empty states).
export const manageGroupsBackground = (warm) => (warm ? colors.milkGlass500 : colors.milkGlass200);

export const ManageGroupsMain = ({ children }) => {
  const [warm, setWarm] = useState(false);
  return (
    <ReportWarmSurface.Provider value={setWarm}>
      <Main $warm={warm}>{children}</Main>
    </ReportWarmSurface.Provider>
  );
};

// Before paint, so the page never shows one frame in the other color.
export const useReportWarmSurface = (warm) => {
  const report = useContext(ReportWarmSurface);
  useLayoutEffect(() => {
    report(warm);
  }, [report, warm]);
};

const Main = styled.div`
  background-color: ${(p) => manageGroupsBackground(p.$warm)};
  padding-top: 24px;
  min-height: calc(100vh - 92px);
`;
